// This file is automatically generated
export const METADATA = {
    "name": "@openai/agents-realtime",
    "version": "0.0.11",
    "versions": {
        "@openai/agents-realtime": "0.0.11",
        "@openai/agents-core": "workspace:*",
        "@openai/zod": "npm:zod@3.25.40 - 3.25.67"
    }
};
export default METADATA;
//# sourceMappingURL=metadata.mjs.map